import React from "react"

import moment from "moment"

import YearTab from "./year-tab-container"
import Year from "./year-container"

import Spinner from 'react-spinkit';

import ScenarioDetail from "../detail/detail-container"
import ScenarioAdmin from "../admin/admin-container"
import ScenarioEquilibrage from '../admin/scenario_index'

import Popup from '../../ppi/ppi-detail/utils/popup'

import ScenarioForm from '../common/scenario-form-container'
import ScenarioThemeValidator from '../admin/scenario-theme-validator-container'

import RetroUpdater from './retro-updater-container'
import '../detail/styles.scss'

class ManagerComponent extends React.Component {

	state = {
		currentYear: parseInt(moment().format("YYYY"))
	}

	render() {
		const nowYear = this.state.currentYear //parseInt(moment().format("YYYY"))
		const selectedYear = this.props.scenarii ? this.props.scenarii.find(s => (s.year == this.state.currentYear)) : null
		const currentYear = (new Date()).getFullYear()
		const uservalide = this.props.me.userType==="ADMIN" ||  this.props.me.userType==="MANAGER_LOCAL_AUTHORITY"
		const currentYearUpdateScenarioParGestionnaire= this.props.currentLocalAuthority? this.props.currentLocalAuthority.currentYearUpdateScenarioParGestionnaire:false
		const nextYearUpdateScenarioParGestionnaire= this.props.currentLocalAuthority? this.props.currentLocalAuthority.nextYearUpdateScenarioParGestionnaire:false
		const iseditable = uservalide ? true : selectedYear == currentYear ? currentYearUpdateScenarioParGestionnaire : selectedYear == currentYear + 1 ? nextYearUpdateScenarioParGestionnaire : false
		const previousYear = this.props.scenarii ? this.props.scenarii.find(s => (s.year == (nowYear - 1))) : null
		const previousValidatedScenarioExists = this.props.scenarii ? (previousYear && previousYear.scenarii.find(s => (s.validated)) !== undefined) : null
		const isshowpopup = iseditable?true:this.props.action=="toggle_valid_theme"?false:true
		return (
			<div className="scenarii-manager">
			{ this.props.loading !== false
				? <div className="ppi-loader">
						<Spinner fadeIn="none" name="wave" color="#3d3c3f" />
						<span>{this.props.loadingStr}</span>
					</div>
				:this.props.loadingSee ? <div id="cover-spin" style={{ display: 'block' }}></div> :this.props.action == "see_scenario"
					?	<ScenarioDetail
							scenarii={this.props.scenarii}
							scenario={this.props.scenario}
							loans={this.props.loans}
							actions={this.props.actions}
							ppi={this.props.ppi}
							onScenarioUpdated={this.props.onScenarioUpdate}
							onScenarioUpdated1={this.props.onScenarioUpdate1}
							onBack={this.props.onBack}
						/>
					:this.props.action == "equilibrage_scenario" || this.props.action == "toggle_valid"?
					<ScenarioEquilibrage
					scenarii={this.props.scenarii}
					scenario={this.props.scenario}
					ppi={this.props.ppi}
					services={this.props.services}
					loans={this.props.loans}
					localAuthority={this.props.currentLocalAuthority}
					onScenarioUpdated={this.props.onScenarioUpdate}
					onBack={this.props.onBack}
					onCustomAction={this.props.onCustomAction}
					actions={this.props.actions}
					/>
					: this.props.action == "manage_scenario" || this.props.action == "toggle_valid_theme"
						?	<ScenarioAdmin
								scenarii={this.props.scenarii}
								scenario={this.props.scenario}
								ppi={this.props.ppi}
								services={this.props.services}
								loans={this.props.loans}
								localAuthority={this.props.currentLocalAuthority}
								onScenarioUpdated={this.props.onScenarioUpdate}
								onBack={this.props.onBack}
								onCustomAction={this.props.onCustomAction}
								actions={this.props.actions}
							/>
						: <div>
								<div className="scenario-year-tabs">
									{ this.props.scenarii.map(year => (
										<YearTab
											key={"year-tab-" + year.year}
											year={year.year}
											current={year.year == this.state.currentYear}
											onSelected={this._handleYearSelected.bind(this)}
										/>
									))}
								</div>
								<Year
									consulted={this.props.consulted}
									year={this.state.currentYear}
									me={this.props.me}
									isGest={this.props.isGest}
									scenarii={selectedYear.scenarii.sort((a, b) => ((a.identifier > b.identifier) ? 1 : -1))}
									couldCreate={selectedYear.scenarii.length == 0}
									previousValidatedScenarioExists={previousValidatedScenarioExists}
									onCreate={this.props.onCreate}
									onCustomAction={this.props.onCustomAction}
								/>
							</div>
			}
				{isshowpopup && this.props.action && ["manage_scenario", "see_scenario","equilibrage_scenario","new_scenario"].indexOf(this.props.action) == -1
					? <Popup onHide={this.props.onHidePopup} title={this._buildPopupTitle()}>
							{this._buildPopupContent()}
						</Popup>
					: null
				}
			</div>
		)
	}

	_handleYearSelected(year) {
		this.setState({currentYear: year})
	}

	_buildPopupTitle() {
		var title = ""
		switch(this.props.action) {
			case "create_scenario":
				title = "Créer un scénario"
				break
			case "update_retro":
				title = "Mettre à jour la retrospective"
				break
			case "edit_scenario":
				title = "Modifier le scénario"
				break
			case "delete_scenario":
				title = "Supprimer le scénario"
				break
			case "duplicate_scenario":
				title = "Dupliquer le scénario"
				break
			case "manage_scenario":
				title = "Gérer les gestionnaires"
				break
			case "see_scenario":
				title = "Afficher le scénario"
				break
			case "new_scenario":
				title = "Afficher le scénario"
				break
			case "valid_scenario":
				title = (this.props.actionData.scenario.validated ? "Invalider" : "Valider") + " le scénario"
				break
			case "toggle_valid_theme":
				title = "Validation des valeurs"
				break
			case "toggle_valid":
				title = "Validation des valeurs"
				break
		}
		return title
	}

	_buildPopupContent() {
		var content = null
		switch(this.props.action) {
			case "create_scenario":
			case "edit_scenario":
			case "delete_scenario":
			case "duplicate_scenario":
			case "valid_scenario":
				content = <ScenarioForm
										scenario={this.props.actionData ? this.props.actionData.scenario : null}
										year={this.state.currentYear}
										delete={this.props.action == "delete_scenario"}
										duplicate={this.props.action == "duplicate_scenario"}
										validate={this.props.action == "valid_scenario"}
										onCreated={this.props.onScenarioCreated}
										onUpdated={this.props.onScenarioUpdated}
										onDeleted={this.props.onScenarioDeleted}
									/>
				break
			case "toggle_valid_theme":
				content = <ScenarioThemeValidator
										scenario={this.props.scenario}
										theme={this.props.actionData.theme}
										onThemeValidated={this.props.onThemeValidated}
										toggle={"toggle_valid_theme"}
									/>
				break
			case "toggle_valid":
				content = <ScenarioThemeValidator
				                        scenario={this.props.scenario}
				                        theme={this.props.actionData.theme}
										onThemeValidated={this.props.onThemeValidated}
										toggle={"toggle_valid"}
			                        />
                break
			case "update_retro":
				content = <RetroUpdater
										scenario={this.props.scenario}
										ppi={this.props.ppi}
										actions={this.props.actions}
										localAuthority={this.props.currentLocalAuthority}
										onRetroUpdated={this.props.onRetroUpdated}
									/>
				break
		}
		return content
	}

}

export default ManagerComponent



// WEBPACK FOOTER //
// ./src/component/scenarii/manager/manager-component.js